import React,{useState, useEffect} from 'react';
import './AptitudeTest.css'
import axios from 'axios'
import {FaArrowAltCircleRight} from 'react-icons/fa'
import {Spin} from 'antd'

const url = "http://strategic-links-api.herokuapp.com/Aptitude_Test/Questions";

const AptitudeTest = () => {
    const [current,setCurrent] = useState(0)
    const [result,setResult] = useState(false)

    //api request

    const [questions,setQuestions] = useState(null);

    useEffect(()=>{
        window.scrollTo(0,0)
    },[])

    useEffect(()=>{
        axios.get('https://strategicapi.herokuapp.com/Aptitude_Test/Questions')
        .then(res=>{
            let data = res.data
            setQuestions(data.slice(0,5))
            console.log(data.slice(0,5))
        })
        .catch(err=>console.log(err))
    },[])

    // const getQuestions = async () =>{
    //     const response = await fetch(url);
    //     const questions = await response.json();
    //     setQuestions(questions);
    //    // console.log(questions);
    // }

    // useEffect(()=>{
    //     getQuestions();
    // },[])


    const [answers,setAnswers] = useState([])

    const moveNext = () => {
        setCurrent(current+1)
        console.log(selected)
        setAnswers([...answers,selected])

        setSelected('')

        if(current===4){
            setResult(true)
            submit()
        }
    }

    const submit = () => {
        // axios({
        //     method: 'POST',
        //     url: "",
        //     data: answers
        // })
        // .then((res)=>{
        //     console.log(res)
        // })
        // .catch((err)=>{
        //     console.log(err)
        // })

        let param = answers.join(' ')
        console.log(param)
    }


    const [selected,setSelected] = useState('')

    return ( 
        <div className='aptitude-container'>
            {
                result ?
                <h3 className='test-submitted'>
                    <Spin size='large'/>
                    <div>preparing your result</div>
                </h3>
                :
                <>
                {
                    questions ?
                    <div>
                        <div className='question-no'>Question {current+1}.</div>
                        <h4 className='question'>{questions[current][0]}</h4>

                        <div className='options-container'>
                            <div onClick={()=>setSelected('1')} className={selected==='1' ? 'option-selected' : 'option'}>{questions[current][1]}</div>
                            <div onClick={()=>setSelected('2')} className={selected==='2' ? 'option-selected' : 'option'}>{questions[current][2]}</div>
                            <div onClick={()=>setSelected('3')} className={selected==='3' ? 'option-selected' : 'option'}>{questions[current][3]}</div>
                            <div onClick={()=>setSelected('4')} className={selected==='4' ? 'option-selected' : 'option'}>{questions[current][4]}</div>
                        </div>

                        {
                            selected===''?
                            <div className='next-container'>
                                {
                                    current===4 ? <>Finish</> : <>Next</>
                                }
                                <FaArrowAltCircleRight className='disabled'/>
                            </div>
                            :
                            <div onClick={moveNext} className='next-container'>
                                {
                                    current===4 ? <>Finish</> : <>Next</>
                                }
                                <FaArrowAltCircleRight className='active'/>
                            </div>
                        }
                    </div>
                    :
                    <h3 className='test-loader'>
                        <Spin size='large'/>
                        <div>loading test</div>
                    </h3>
                }
                </>
            }
        </div>
     );
}
 
export default AptitudeTest;